import { filter, get } from 'lodash';

export const getAreAllSeriesSelected = ({ study }: any) => {
  const series = get(study, 'loadedSeries', []);
  const selectedSeries = filter(series, (serie) => serie.serieIsSelected === true);
  return series.length === selectedSeries.length;
};
